module.exports = __webpack_public_path__ + "static/media/lupa.0bea1b99.svg";